<template>
    <select
        ref="select"
        v-on:change="selectCharacter($event)"
        class="character-dialog form-control"
        v-on:blur="$emit('select-character')"
    >
        <option>Choose a character</option>
        <option
            v-on:click="selectCharacter($event)"
            v-for="(character, index) in characters"
            :value="index"
        >{{ getDisplayName(character) }}</option>
    </select>
</template>

<script>
export default {
    props: [ 'snickId' ],
    methods: {
        getDisplayName(character) {
            const scope = '';
            const name  = character.display_name || character.name;
            return scope + name;
        },
        getCharacters() {
            const characterUrl = `/docus/${this.snickId}/characters`;
            axios.get(characterUrl).then((response) => {
                this.characters = response.data;
                this.$refs.select.focus();
            }).catch((error) => {
                console.log('Failed to retrieve characters');
            });
        },
        selectCharacter(event) {
            const index = event.srcElement.value;
            this.$emit('select-character', this.characters[index]);
        }
    },

    data () {
        return {
            characters: [],
        };
    },
    mounted() {
        this.getCharacters();
    }
};
</script>

<style lang="css" scoped>
</style>
